export class NAReason {
  constructor(
    public id: string,
    public text: string,
	 public derfault?: boolean,
    public status?: boolean
  ) { }
}
